// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GoogleChromeLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3Zm0 2a11 11 0 0 1 9.215 5H16a6.01 6.01 0 0 0-5.7 4.125l-2.885-5A10.986 10.986 0 0 1 16 5Zm4 11a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5 16a10.93 10.93 0 0 1 1.195-4.982L10.804 19c.007.012.016.024.024.035a6 6 0 0 0 6.4 2.84l-2.888 5A11.018 11.018 0 0 1 5 16Zm11.586 10.984L21.196 19l.028-.052a5.986 5.986 0 0 0-.75-6.948h5.776a11 11 0 0 1-9.661 14.984h-.003Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
